import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import merge from 'deepmerge'
import { compactAndFilter } from '@/utils'

const module = 'clients'
let doc = {
  list: {
    name: 'Clients',
    headers: [
      { label: 'Nom', value: 'name' },
      { label: 'Contact', value: 'contact_name' },
      { label: 'Email', value: 'email' },
      { label: 'Téléphone', value: 'phone', align: 'right' },
    ],
    actions: [
      { icon: 'add', isFlat: false, scope: ['clients.create'], dispatch: `${module}/openForm` },
      { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
    ],
    selectActions: [
      {
        label: 'Supprimer',
        icon: 'delete',
        scope: ['clients.delete'],
        dispatch: `${module}/batchDelete`,
        context: {confirm: true},
        menu: true,
      },
    ],
    dataActions: [
      { icon: 'visibility', dispatch: `${module}/goTo` },
    ],
    search: [
      { label: 'Nom', type: 'text', name: 'name', classes: 'xs12' },
    ],
  },

  form: {
    name: 'Client',
    hasPhoto: true,
    actions: [
      { icon: 'save', filter: {edit: true}, scope: ['clients.update'], dispatch: `${module}/update` },
      { icon: 'delete', isFlat: true, scope: ['clients.delete'], dispatch: `${module}/delete` },
      { label: 'Panier', icon: 'exposure_plus_1', scope: ['baskets.create'], dispatch: `${module}/createBasket` },
      { label: 'Visuel', icon: 'exposure_plus_1', scope: ['visuals.create'], dispatch: `${module}/createVisual` },
    ],
    fields: [
      { label: 'Code', type: 'text', name: 'code' },
      { label: 'Nom', type: 'text', name: 'name' },
      { label: 'Email', type: 'text', name: 'email' },
      { label: 'Contact', type: 'text', name: 'contact_name', hint: "Nom du contact dans l'entreprise" },
      { label: 'Téléphone', type: 'text', name: 'phone' },
    ],
    relations: [
      {
        name: 'Paniers',
        source: 'baskets',
        headers: [
          { label: 'Début', value: 'dateStart', card: false },
          { label: 'Fin', value: 'dateEnd', card: false },
          { label: 'Nom', value: 'name' },
          { label: 'Statut', value: 'status.name' },
          { label: 'Dates', value: 'dates', sortable: false, inTable: false },
        ],
        dispatch: 'getBaskets',
        dataActions: [
          { icon: 'visibility', isFlat: false, dispatch: `baskets/goTo` },
        ],
      },
    ],
  },

  params: {
    fetchOne: {include: 'baskets.status'},
  },
}

const base = crudmaker(module, apiClient, doc)

const custom = {
  actions: {
    getBaskets: ({ commit }, payload) => {
      const { context, data } = payload
      commit('SET_LOADING', true)
      commit('baskets/LIST_REQUEST', payload, {root: true})
      let compacted = compactAndFilter(data)
      let params = {
        ...compacted,
        client_id: context.id,
        include: 'status',
      }
      apiClient.fetchCustom('baskets', `baskets`, params)
        .then(data => {
          commit('baskets/LIST_SUCCESS', data, {root: true})
          commit('SET_LOADING', false)
        })
        .catch(error => {
          commit('baskets/LIST_ERROR', error, {root: true})
          commit('SET_LOADING', false)
        })
    },
    createBasket: ({ commit, dispatch }, payload) => {
      console.log(payload)
      const { context } = payload
      dispatch('baskets/goToList', {}, {root: true})
      commit('baskets/UPDATE_FORM_FIELD', {key: 'client_id', value: parseInt(context.id)}, {root: true})
      commit('baskets/OPEN_FORM', {client_id: context.id}, {root: true})
    },
    createVisual: ({ commit, dispatch }, payload) => {
      console.log(payload)
      const { context } = payload
      dispatch('visuals/goToList', {}, {root: true})
      commit('visuals/UPDATE_FORM_FIELD', {key: 'client_id', value: parseInt(context.id)}, {root: true})
      commit('visuals/OPEN_FORM', {client_id: context.id}, {root: true})
    },
  },
}
export default merge(base, custom)
